/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-c95cf239.js';

const globalScripts = initialize;

export { globalScripts as g };
